import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../../hooks'

export const Fraud = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="suspiciousActivityInfo.fraud"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="34. Fraud"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'34. Fraud'}
              direction={'vertical'}
              data={[
                { label: 'a. ACH', value: 'a' },
                { label: 'b. Advance fee', value: 'b' },
                { label: 'c. Business loan', value: 'c' },
                { label: 'd. Check', value: 'd' },
                { label: 'e. Consumer loan', value: 'e' },
                { label: 'f. Credit/Debit card', value: 'f' },
                { label: 'g. Healthcare/Public or private health insurance', value: 'g' },
                { label: 'h. Mail', value: 'h' },
                { label: 'i. Mass-marketing', value: 'i' },
                { label: 'j. Ponzi scheme', value: 'j' },
                { label: 'k. Pyramid scheme', value: 'k' },
                { label: 'l. Securities fraud', value: 'l' },
                { label: 'm. Wire', value: 'm' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
